import React from 'react';

import { PreviewModeButton, PreviewModeContainer } from './PreviewMode.style';

export const PreviewMode = () => {
  return (
    <div css={PreviewModeContainer} data-testid="PreviewMode">
      Preview Mode
      <a href="/api/clearPreview" css={PreviewModeButton} data-testid="PreviewModeButton">
        Exit Preview Mode
      </a>
    </div>
  );
};
